export const APP_NAME = 'PaperTranslate';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '0.1.0';
export const APP_TAGLINE = '面向科研论文的 AI 翻译平台';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
export const WS_BASE_URL = import.meta.env.VITE_WS_BASE_URL ?? '/api/v1/ws';

export const STORAGE_KEYS = {
  auth: 'pt.auth',
  task: 'pt.task',
  quota: 'pt.quota',
} as const;

export const FILE_LIMITS = {
  maxBytes: 50 * 1024 * 1024,
  maxPages: 100,
  glossaryMaxBytes: 1024 * 1024,
} as const;

export const ACCEPTED_PDF_MIME = ['application/pdf'];

export const SUPPORTED_LANGUAGES = [
  { code: 'auto', label: '自动检测' },
  { code: 'en', label: '英语' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日语' },
  { code: 'ko', label: '韩语' },
  { code: 'fr', label: '法语' },
  { code: 'de', label: '德语' },
  { code: 'es', label: '西班牙语' },
  { code: 'ru', label: '俄语' },
] as const;

export const TRANSLATION_SERVICES = [
  { code: 'siliconflow', label: 'DeepSeek-V4-Flash', description: 'SiliconFlow · 快且稳定' },
] as const;

export type BillingCycle = 'monthly' | 'annual';

export const PLAN_DEFINITIONS = [
  {
    code: 'free',
    name: '免费档',
    priceCny: 0,
    annualPriceCny: null,
    priceLabel: '¥0',
    annualPriceLabel: null,
    periodLabel: '永久',
    annualPeriodLabel: null,
    pagesPerMonth: 30,
    pagesPerDay: 5,
    glossaries: 1,
    features: ['30 页/月', '每日 5 页', '1 个术语库', '标准翻译服务'],
    highlight: false,
  },
  {
    code: 'standard',
    name: '标准档',
    priceCny: 29,
    annualPriceCny: 249,
    priceLabel: '¥29',
    annualPriceLabel: '¥249',
    periodLabel: '/月',
    annualPeriodLabel: '/年',
    pagesPerMonth: 200,
    pagesPerDay: null,
    glossaries: 5,
    features: [
      '200 页/月',
      '5 个术语库',
      '多 PDF 格式导出(单/双语)',
      '邮件支持',
    ],
    highlight: true,
  },
  {
    code: 'pro',
    name: 'Pro 档',
    priceCny: 69,
    annualPriceCny: 599,
    priceLabel: '¥69',
    annualPriceLabel: '¥599',
    periodLabel: '/月',
    annualPeriodLabel: '/年',
    pagesPerMonth: 500,
    pagesPerDay: null,
    glossaries: 20,
    features: [
      '500 页/月',
      '20 个术语库',
      '优先队列',
      '7×24 优先支持',
    ],
    highlight: false,
  },
] as const;

export const TOPUP_PACKAGES = [
  { pages: 50, priceCny: 9, priceLabel: '¥9', unitPrice: '¥0.18/页' },
  { pages: 100, priceCny: 15, priceLabel: '¥15', unitPrice: '¥0.15/页' },
] as const;

export type PlanCode = (typeof PLAN_DEFINITIONS)[number]['code'];
export type TopupPages = (typeof TOPUP_PACKAGES)[number]['pages'];

export const SOURCE_CODE_URL = 'https://github.com/your-org/paper-translate';
export const LICENSE_URL = 'https://www.gnu.org/licenses/agpl-3.0.html';
export const CONTACT_EMAIL = 'hello@paper-translate.dev';

export const PAYMENT_METHODS = [
  { code: 'paddle', label: 'Paddle(国际卡 / PayPal)' },
  { code: 'wechat', label: '微信支付(历史)' },
  { code: 'alipay', label: '支付宝(历史)' },
] as const;

export const ORDER_TYPES = [
  { code: 'subscription', label: '套餐订阅' },
  { code: 'topup', label: '加油包' },
] as const;
